"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.useControlState = function (_a) {
    var _b = _a === void 0 ? {} : _a, onBlur = _b.onBlur, rootRef = _b.rootRef, onFocus = _b.onFocus, onPreventBlur = _b.onPreventBlur;
    var preventBlurFlagRef = react_1.useRef(false);
    var _c = react_1.useState(false), focused = _c[0], setFocused = _c[1];
    var _d = react_1.useState(false), active = _d[0], setActive = _d[1];
    var focus = function () {
        setFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    };
    var blur = function () {
        setFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    };
    var activate = function () {
        setActive(true);
    };
    var deactivate = function () {
        setActive(false);
    };
    var preventBlur = function () {
        preventBlurFlagRef.current = true;
    };
    return {
        focused: focused,
        active: active,
        focus: focus,
        blur: blur,
        input: {
            onBlur: function (event) {
                var _a;
                event === null || event === void 0 ? void 0 : event.stopPropagation();
                if (preventBlurFlagRef.current) {
                    preventBlurFlagRef.current = false;
                    (_a = rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    onPreventBlur === null || onPreventBlur === void 0 ? void 0 : onPreventBlur();
                    return;
                }
                blur();
                deactivate();
            },
            onFocus: function (event) {
                event === null || event === void 0 ? void 0 : event.stopPropagation();
                focus();
            }
        },
        activate: activate,
        deactivate: deactivate,
        preventBlur: preventBlur
    };
};
//# sourceMappingURL=useControlState.js.map